<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-responsive max-width="1440px" width="100%">
                <dashboard-pin></dashboard-pin>
            </v-responsive>
        </v-layout>
    </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import DashboardPin from "@/components/console/dashboard/dashboard-pin.vue";

export default {
    components: {
        DashboardPin
    },
    mounted() {
        if(this.hasViewerScope) this.addEvents();
    },
    beforeDestroy(){
        if(this.hasViewerScope) this.removeEvents();
    },
    methods:{
        preventDefault(e) {
            e.preventDefault()
        },
        addEvents() {
            //마우스 오른쪽 방지
            document.addEventListener('contextmenu', this.preventDefault);
            //텍스트 선택 방지
            document.addEventListener('selectstart', this.preventDefault);
            //복사 금지
            document.addEventListener('copy', this.preventDefault);
        },
        removeEvents() {
            //마우스 오른쪽 방지
            document.removeEventListener('contextmenu', this.preventDefault);
            //텍스트 선택 방지
            document.removeEventListener('selectstart', this.preventDefault);
            //복사 금지
            document.removeEventListener('copy', this.preventDefault);
        }
        
    },
    computed: {
        ...mapGetters(["hasViewerScope"]),
        payload(){
            return this.$store.state.payload || {};
        },
        scope(){
            return this.payload.scope || [];
        }
    }
}
</script>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: 100%;
}
</style>
